<template>
    <div class="max-w-lg mx-auto">
        <div class="card">
            <h4 class="card__title">Redigera utskick</h4>
            <text-input
                v-model="subject"
                name="subject"
                label="Ämne"
                :required="true"
            />

            <slot />
        </div>
        <div class="card">
            <template v-if="isSalesProject">
                <h4 class="mb-sm">
                    Säljomgångar vars signerade kunder ska nås av detta utskick
                </h4>
                <h5 class="mb-lg">
                    Inom parentes anges hur många adresser som har en e-post kopplad till sig.
                </h5>
                <div class="grid">
                    <div
                        v-for="salesPeriod in salesPeriods"
                        class="column w-full md:w-1/2 mb-md"
                    >
                        <checkbox-input
                            v-if="mailshot.status === 'draft'"
                            v-model="salesPeriod.checked"
                            name="sales_period_ids[]"
                            :value="salesPeriod.id"
                            @toggle="salesPeriodToggled"
                        >
                            {{ salesPeriod.name }} ({{ salesPeriod.has_email_count }} st)
                        </checkbox-input>
                        <span v-else-if="salesPeriod.checked">
                            {{ salesPeriod.name }} ({{ salesPeriod.has_email_count }} st)
                            <checkbox-input
                                v-model="salesPeriod.checked"
                                name="sales_period_ids[]"
                                :value="salesPeriod.id"
                                style="display: none;"
                            />
                        </span>
                    </div>
                </div>
            </template>
            <template v-else>
                Antal adresser med e-postadress kopplad till sig: {{ deliveryRecipientsCount }}
            </template>
        </div>

        <div class="flex justify-between">
            <a
                class="btn is-ghost btn-lg"
                :href="cancelUrl"
                tabindex="2"
            >
                Avbryt
            </a>
            <div>
                <button type="submit" class="btn is-primary btn-lg">
                    Spara som utkast
                </button>               
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                type: Object,
                required: true,
            },
            isSalesProject: {
                type: Boolean,
                required: true,
            },
            mailshot: {
                type: Object,
                required: true,
            },
            initialSalesPeriods: {
                type: Array,
                default: null,
            },
            deliveryRecipientsCount: {
                type: Number,
                default: null,
            },
        },

        data() {
            return {
                subject: this.mailshot.subject,
                sendIsEnabled: this.isSalesProject ? false : this.deliveryRecipientsCount > 0,
                salesPeriods: this.initialSalesPeriods,
            };
        },
        computed: {
            cancelUrl() {
                return route('admin.mailshots.show', this.mailshot);
            },
        },

        methods: {
            salesPeriodToggled() {
                this.sendIsEnabled = false;

                this.salesPeriods.map(salesPeriod => {
                    if (salesPeriod && salesPeriod.checked && salesPeriod.has_email_count > 0) {
                        this.sendIsEnabled = true;
                    }
                });
            },
        },
    };
</script>
